import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';


@Injectable({providedIn: 'root'})
export class ApValidationService {

  private baseUrl: string = environment.DEV_apiUrl;

  constructor(private http: HttpClient) { }

  apValidation(params: any): Observable<any> {
    const currentLang = localStorage.getItem('lang') || 'es';
    return this.http.post<any>(`${this.baseUrl}/${currentLang}/api/connectivity/validateAp`, params);
  }

}

